import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, Row, Col, Alert } from 'reactstrap';
import { ADD_SAV_AGENT } from '../../query/query';
import { withApollo } from 'react-apollo';

function ErrorMail(props) {
  return (
    <div>
      {props.error &&
        <Alert color="danger">
          Il n'y a pas d'utilisateur associé à ce mail
        </Alert>
      }
    </div>
  );
}

class AddSAVAgent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      error: false,
    };

    this.handleAdd = this.handleAdd.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.refreshAgents = this.refreshAgents.bind(this);
  }

  handleAdd(e) {
    e.preventDefault();
    const email = this.state.email;
    this.props.client.query({
      query: ADD_SAV_AGENT,
      variables: {
        email,
      },
    }).then(({ data }) => {
      if (data.savAddAgent) {
        this.refreshAgents();
        this.setState({
          email: '',
        });
      } else {
        this.setState({
          error: true,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  handleEmailChange(e) {
    this.setState({
      email: e.target.value,
      error: false,
    });
  }

  refreshAgents() {
    this.props.refresh();
  }

  render() {
    return (
      <Form onSubmit={this.handleAdd}>
        <FormGroup>
          <Label>Ajouter nouveau compte SAV</Label>
          <Row>
            <Col>
              <Input
                type="email"
                value={this.state.email}
                onChange={this.handleEmailChange}
              />
            </Col>
            <Col>
              <Button
                type="submit"
                color="success"
              >
                Ajouter
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs="6">
              <ErrorMail error={this.state.error} />
            </Col>
          </Row>
        </FormGroup>
      </Form>
    );
  }
}

export default withApollo(AddSAVAgent);



// WEBPACK FOOTER //
// ./src/components/admin/add-sav-agent.js